const Privacy = () => {
  return (
    <div className="legal-wrap" data-testid="privacy-page">
      <a className="legal-back" href="/" data-testid="privacy-back-link">
        ← Back to FortellAI
      </a>
      <h1>Privacy Policy</h1>
      <p className="legal-updated">FortellAI · Last updated June 2026</p>

      <h2>1. Entertainment Only</h2>
      <p>
        FortellAI is an entertainment application. All readings — palm, coffee, aura and object
        interpretations — are AI-generated for fun and inspiration. They are not professional,
        medical, legal, financial or psychological advice.
      </p>

      <h2>2. Photos You Submit</h2>
      <p>
        Photos you capture or upload are transmitted securely to our servers solely to generate
        your reading and are processed transiently by our AI provider. We do not use your photos to
        identify you, we do not perform face recognition, and we do not store biometric data or
        biometric templates of any kind.
      </p>

      <h2>3. Data We Store</h2>
      <p>
        We store the text of readings you choose to save, an anonymous device identifier, and your
        subscription status. We do not require an account, name, or email address. Saved readings
        can be deleted by you at any time from your profile.
      </p>

      <h2>4. Subscriptions &amp; Payments</h2>
      <p>
        Premium subscriptions are billed through Apple App Store or Google Play. We never see or
        store your payment card details — all payment processing is handled by Apple or Google.
      </p>

      <h2>5. Advertising</h2>
      <p>
        Free-tier users may be shown non-personalized ads served by Google AdMob. Premium
        subscribers are not shown ads.
      </p>

      <h2>6. Children</h2>
      <p>
        FortellAI is not directed at children under 13, and we do not knowingly collect personal
        information from children.
      </p>

      <h2>7. Changes &amp; Contact</h2>
      <p>
        We may update this policy from time to time; the latest version will always be available at
        www.fortellai.ca. Questions? Contact us through www.fortellai.ca.
      </p>
    </div>
  );
};

export default Privacy;
